import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Donate from "./Donate";
import DonateToUs from "./DonateToUs";
import Adopt from './AdoptableDog';
import Foster from './FosterHome';

const Home = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [isExtraSmallScreen, setIsExtraSmallScreen] = useState(false);

    const updateScreenSize = () => {
        setIsSmallScreen(window.innerWidth <= 1240);
        setIsExtraSmallScreen(window.innerWidth <= 970);
    };

    useEffect(() => {
        updateScreenSize();
        window.addEventListener('resize', updateScreenSize);
        return () => {
            window.removeEventListener('resize', updateScreenSize);
        };
    }, []);

    return (
        <div className="container-fluid p-3 p-md-5">
            {/* Contact section */}
            <div className="row justify-content-center align-items-stretch home-contact mb-5">
                {/* Address */}
                <div className="col-12 col-md-6 col-lg-4 mb-4 d-flex">
                    <div style={{ position: "relative", width: "100%" }}>
                        <h2
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "white",
                                zIndex: "1",
                                fontWeight: "600",
                                textAlign: "center",
                                fontSize: isSmallScreen
                                    ? (isExtraSmallScreen ? '20px' : '27.5px')
                                    : '35px',
                                padding: "0 10px",
                                lineHeight: "1.2"
                            }}
                        >
                            Postaszállás, Mattyi út, Siklós, Hungary
                        </h2>
                        <img
                            src="../img/home-1.jpg"
                            alt="address"
                            style={{
                                maxHeight: "500px",
                                width: "100%",
                                objectFit: "cover",
                                borderRadius: "15px"
                            }}
                        />
                    </div>
                </div>

                {/* Phone */}
                <div className="col-12 col-md-6 col-lg-4 mb-4 d-flex">
                    <div style={{ position: "relative", width: "100%" }}>
                        <h2
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "white",
                                zIndex: "1",
                                fontWeight: "600",
                                textAlign: "center",
                                fontSize: isSmallScreen
                                    ? (isExtraSmallScreen ? '20px' : '27.5px')
                                    : '35px',
                                padding: "0 10px",
                                lineHeight: "1.2"
                            }}
                        >
                            +36 70 587 6260
                        </h2>
                        <img
                            src="../img/home-2.jpg"
                            alt="phone"
                            style={{
                                maxHeight: "500px",
                                width: "100%",
                                objectFit: "cover",
                                borderRadius: "15px"
                            }}
                        />
                    </div>
                </div>

                {/* Email */}
                <div className="col-12 col-md-6 col-lg-4 mb-4 d-flex">
                    <div style={{ position: "relative", width: "100%" }}>
                        <h2
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "white",
                                zIndex: "1",
                                fontWeight: "600",
                                textAlign: "center",
                                fontSize: isSmallScreen
                                    ? (isExtraSmallScreen ? '18px' : '25.5px')
                                    : '35px',
                                padding: "0 10px",
                                lineHeight: "1.3",
                                wordBreak: "break-word"
                            }}
                        >
                            tenkesaljaallatvedoe<br />gyesulet@gmail.com
                        </h2>
                        <img
                            src="../img/home-3.jpg"
                            alt="email"
                            style={{
                                maxHeight: "500px",
                                width: "100%",
                                objectFit: "cover",
                                borderRadius: "15px"
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Adoptable Dogs */}
            <div
                className="py-5 my-5 text-center"
                style={{
                    width: "100vw",
                    position: "relative",
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw",
                    backgroundColor: "#f0f9ff", // soft blue tone for variety
                    boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)"
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Adopt limit={6} />
                        </div>
                    </div>
                    <div className="text-center my-4">
                        <button
                            className="btn btn-success px-4 py-2"
                            style={{ fontSize: isExtraSmallScreen ? "14px" : "16px" }}
                            onClick={() => navigate("/adopt")}
                        >
                            {t("common.seeMore", "See All Our Adoptables")}
                        </button>
                    </div>
                </div>
            </div>


            {/* Ways You Can Help Section */}
            <div
                className="row my-5 text-center py-5"
                style={{
                    width: "100vw",
                    position: "relative",
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw",
                    backgroundColor: "#e9f7ef",
                    boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)",
                    paddingLeft: isExtraSmallScreen ? "1rem" : "2rem",
                    paddingRight: isExtraSmallScreen ? "1rem" : "2rem",
                }}
            >
                <div className="container">
                    <div className="col-12">
                        <h2
                            className="mb-4 fw-bold"
                            style={{
                                fontSize: isExtraSmallScreen ? "24px" : "32px",
                                lineHeight: "1.3",
                            }}
                        >
                            {t("home.volunteerSectionTitle")}
                        </h2>
                        <p
                            className="lead"
                            style={{
                                maxWidth: "900px",
                                margin: "0 auto",
                                fontSize: isExtraSmallScreen ? "16px" : "20px",
                            }}
                        >
                            {t("home.volunteerSectionText")}
                        </p>
                        <button
                            className="btn btn-primary mt-3 px-4 py-2"
                            style={{
                                fontSize: isExtraSmallScreen ? "14px" : "16px",
                                marginTop: "1.5rem",
                            }}
                            onClick={() => navigate("/volunteer")}
                        >
                            {t("home.volunteerSectionButton")}
                        </button>
                    </div>

                    {/* Placeholder Images */}
                    <div className="row justify-content-center mt-5 gx-3 gy-4">
                        <div className="col-12 col-md-4 mb-3">
                            <img
                                src="../img/walking-a-dog.jpg"
                                alt="Walking dogs"
                                title='Walking a dog'
                                className="img-fluid rounded shadow-sm w-100"
                            />
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                            <img
                                src="../img/feeding-dogs.png"
                                alt="Feeding animals"
                                title='Feeding the dogs'
                                className="img-fluid rounded shadow-sm w-100"
                            />
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                            <img
                                src="../img/cleaning-kennels.png"
                                alt="Cleaning kennels"
                                title='Cleaning the kennels'
                                className="img-fluid rounded shadow-sm w-100"
                            />
                        </div>
                    </div>
                </div>
            </div>


            {/* Donations */}
            <div
                className="py-5 my-5 text-center"
                style={{
                    width: "100vw",
                    position: "relative",
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw",
                    backgroundColor: "#fff8e1",
                    boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)"
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Donate />
                        </div>
                    </div>
                </div>
            </div>


            <div
                className="py-5 my-5 text-center"
                style={{
                    width: "100vw",
                    position: "relative",
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw",
                    backgroundColor: "#fff3e0",
                    boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)"
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <DonateToUs />
                        </div>
                    </div>
                </div>
            </div>

            {/* Foster */}
            <div
                className="py-5 text-center"
                style={{
                    width: "100vw",
                    position: "relative",
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw",
                    backgroundColor: "#f3f0ff",
                    boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)",
                    marginBottom: "0",
                    paddingBottom: "0",
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Foster />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Home;
